import styled from "styled-components";

export const CompanyIcon = styled.div`
  width: 100%;
  margin-bottom: 8px;
  text-align: center;
  display: block;
  height: 90px;
  img {
    height: auto;
    max-height: 100%;
    max-width: 100%;
    margin-bottom: 0px;
    text-align: center;
  }
`;

export const Profile = styled.div`
  display: flex;
  img {
    width: 64px;
    height: 64px;
    object-fit: cover;
    object-popsition: top;
  }
`;
export const ProfileImg = styled.span`
  width: 100px;
`;

export const ProfileTextContent = styled.span`
  margin-left: 8px;
  overflow: auto;
`;

export const ProfileName = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.secondaryFont};
  font-size: ${({ theme }) => theme.fontSizes.font4} !important;
  font-style: normal;
  text-align: left;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  line-height: ${({ theme }) => theme.lineHeights.line6};
  text-transform: capitalize;
  font-weight: 500;
  @media (max-width: 768px) {
    font-size: ${({ theme }) => theme.fontSizes.font5} !important;
  }
`;

export const ProfileCompanyName = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.primaryFont};
  font-size: ${({ theme }) => theme.fontSizes.font7} !important;
  font-style: normal;
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  font-weight: 500;
  @media (max-width: 768px) {
    font-size: ${({ theme }) => theme.fontSizes.font8} !important;
  }
`;

export const ProfileAccountName = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.primaryFont};
  font-size: ${({ theme }) => theme.fontSizes.font7} !important;
  font-style: normal;
  text-align: left;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.colors.themePrimary || "#0D5FBE"};
  overflow: hidden;
  font-weight: 600;
  white-space: nowrap;
  @media (max-width: 768px) {
    font-size: ${({ theme }) => theme.fontSizes.font8} !important;
  }
`;

export const SidbarMenuMainCont = styled.div`
  .pro-sidebar
    .pro-sidebar-content
    .pro-menu
    .pro-menu-item
    .pro-inner-item:hover
    .pro-icon-wrapper
    .pro-icon {
    animation: none;
  }
  .pro-sidebar.collapsed {
    width: 74px;
    min-width: 74px;
    .pro-sidebar-header .pro-inner-item {
      padding: 0px 8px 0px 8px !important;
    }
  }
  .pro-sidebar {
    transition: none !important;
    height: 100vh;
    box-shadow: 2px 2px 8px ${({ theme }) => theme.colors.grayL5 || "#CCCCCC"};

    .pro-sidebar-inner {
      .pro-sidebar-layout {
        overflow-y: overlay;
        z-index: 402;
      }
    }

    .pro-menu.shaped .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
      background-color: transparent;
      transition: none !important;
      width: 36px;
      min-width: 36px;
      height: 36px;
      margin-right: 8px;
      :hover {
        transition: none !important;
      }
    }
    .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item {
      background-color: transparent;
    }
    > .pro-sidebar-inner {
      background: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
    }
    .pro-sidebar-header {
      .pro-menu {
        .pro-menu-item {
          .pro-inner-item {
            padding: 0px 16px 0px 16px;
          }
        }
      }
    }

    .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
      transform: rotate(90deg);
    }

    .pro-sidebar-content {
      .pro-menu {
        margin-bottom: 0px;
        max-height: 65vh;
        overflow: auto;
        padding-top: 0px;
        padding-bottom: 3px;
        .pro-menu-item {
          .pro-inner-item {
            padding: 4px 16px;
          }

          span.pro-arrow-wrapper {
            right: 16px;

            .pro-arrow {
              display: inline-block;
              content: "";
              border: none;
              width: 10px;
              /*  height: 10px;
              background-image: url("../src/assets/ArrowRight.svg"); */
              background-size: contain;
              background-repeat: no-repeat;
              vertical-align: middle;
              transition: transform 0.3s;
              transform: rotate(0deg);
            }

            .pro-arrow::before {
              font-family: "siera-font-icons";
              content: "=";
              display: inline-block;
              padding-right: 3px;
              vertical-align: middle;
              font-weight: 900;
              font-size: 12px;
            }

            .pro-arrow-wrapper.open .pro-arrow {
              transform: rotate(180deg);
            }
          }
        }
        ul {
          li {
            :hover {
              .pro-inner-item {
                span.pro-icon-wrapper {
                  span.pro-icon {
                    i {
                      font-size: 28px;
                      filter: none;
                      color: ${({ theme }) => theme.colors.themePrimary || "#0D5FBE"};
                    }
                  }
                }
              }
            }
          }
        }
        .active {
          background-color: rgba(0, 0, 0, 0.08);
          .pro-inner-item {
            span.pro-icon-wrapper {
              span.pro-icon {
                i {
                  font-size: 24px;
                  filter: none;
                  color: ${({ theme }) => theme.colors.themePrimary || "#0D5FBE"};
                }
              }
            }
          }
        }
        .open {
          background-color: rgba(0, 0, 0, 0.08);
          .pro-inner-item {
            span.pro-icon-wrapper {
              span.pro-icon {
                i {
                  font-size: 28px;
                  filter: none;
                  color: ${({ theme }) => theme.colors.themePrimary || "#0D5FBE"};
                  .cls-1 {
                    color: ${({ theme }) => theme.colors.themePrimary || "#0D5FBE"};
                  }
                }
              }
            }
          }
        }
        .pro-menu-item {
          color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
          font-family: ${({ theme }) => theme.fontFamily.primaryFont};
          font-size: ${({ theme }) => theme.fontSizes.font7} !important;
          font-weight: 600;
          :hover div span span i {
            font-size: 28px;
          }
          .pro-inner-item {
            /* padding: 5px 35px 5px 15px;*/
            &:focus {
              background-color: rgba(0, 0, 0, 0.08);
              color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
            }
            &:active {
              background-color: rgba(0, 0, 0, 0.08);
              color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
            }
            &:hover {
              color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
              .pro-icon-wrapper {
                .pro-icon {
                  animation: scale (1);
                  i {
                    font-size: 28px;
                    filter: none;
                    color: ${({ theme }) => theme.colors.themePrimary || "#0D5FBE"};
                  }
                }
              }
            }

            .pro-icon-wrapper {
              .pro-icon {
                /*  animation: scale (1); */
                i {
                  font-size: 24px;
                  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
                  display: flex;
                  &:hover {
                    font-size: 28px;
                  }
                }
              }
            }
          }
          .pro-sub-menu {
            .pro-inner-list-item {
              .pro-inner-item {
                padding: 8px 28px 4px 15px;
              }
            }
          }
        }

        ul {
          .pro-sub-menu {
            .pro-inner-list-item {
              padding: 0px;
              div {
                ul {
                  padding-top: 0px;
                  padding-bottom: 0px;
                  margin-left: 0px;
                  li {
                    div {
                      span.pro-item-content {
                        padding-left: 52px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .sidebar-btn-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    .sidebar-btn {
      padding: 1px 15px;
      border-radius: 40px;
      background: rgba(255, 255, 255, 0.05);
      color: ${({ theme }) => theme.colors.grayL5 || "#CCCCCC"};
      text-decoration: none;
      margin: 0 auto;
      height: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-overflow: ellipsis;
      overflow: hidden;
      span {
        margin-left: 5px;
        font-size: ${({ theme }) => theme.fontSizes.font8};
      }
      &:hover {
        color:;
      }
    }
  }

  .collapsed {
    .pro-sidebar-inner {
      .pro-sidebar-layout {
        .pro-sidebar-content {
          nav.pro-menu {
            ul {
              li.pro-sub-menu {
                .pro-inner-item {
                  :hover {
                    span.pro-icon-wrapper {
                      span.pro-icon {
                        background: ${({ theme }) => theme.colors.themePrimary || "#0D5FBE"};
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    .pro-menu {
      ul {
        .pro-sub-menu {
          &:hover {
            > .pro-inner-list-item {
              transition:
                visibility,
                transform 0.3s;
              visibility: visible;
            }
            .pro-icon-wrapper {
              .pro-icon {
                animation: scale (1);
              }
            }
          }
        }
        .pro-menu-item.pro-sub-menu {
          .pro-inner-list-item {
            .popper-inner {
              background-color: ${({ theme }) => theme.colors.themePrimary || "#0D5FBE"};
              padding-left: 0px;
              ul {
                margin-left: 0px !important;
                li.pro-menu-item {
                  div {
                    padding: 10px 10px 10px 10px;
                    span {
                      color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
                      padding-left: 0px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    .sidebar-btn {
      display: inline-block;
      border-radius: 50%;
      width: 35px;
      height: 35px;
      line-height: 40px;
      padding: 0;
    }
  }

  .pro-sidebar.collapsed .pro-menu {
    > ul {
      > .pro-menu-item.pro-sub-menu {
        &:hover {
          .pro-icon-wrapper {
            .pro-icon {
              animation: scale (2);
              i {
                font-size: 28px;
                filter: none;
                color: ${({ theme }) => theme.colors.themePrimary || "#0D5FBE"};
              }
            }
          }
        }
      }
    }
  }
`;
